import React from "react";
import {AdminIndividualNeedsList} from "Views/IndividualNeeds/AdminIndividualNeedsList";

export const SpecialNeedsDashboard : React.FC = () => {
    return (
        <AdminIndividualNeedsList />
    )
}
